import { generateAction } from '../builder'

const getAudiences = generateAction('getAudiences', 'admin/audiences')
const getAudience = generateAction('getAudience', 'admin/audiences/{id}')

export default {
  getAudiences,
  getAudience,
}
